import {get} from '/@/utils/http';

/**
 * @description 是否启用EAM
 * @returns
 */
export const getEAMStatus = async () => await get<boolean>({url: '/api/deploy/system/status/z1-enabled'});
